import { ExclamationMarkTriangleFilled } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { pluralizeNext } from "shared/Pluralize";

import { ScansListItem } from "../../../types";

const ScansTableUnmanagedResourcesCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => {
  const unmanagedCount = scan.latestRun?.resourceStats.unmanaged;

  if (!unmanagedCount) {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellEmpty />
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center" gap="small">
        <Icon src={ExclamationMarkTriangleFilled} color="warning" noShrink />
        <TextEllipsis tooltip={pluralizeNext(unmanagedCount, "resource")}>
          {(props) => (
            <Typography {...props} tag="span" variant="p-body3" color="warning">
              {pluralizeNext(unmanagedCount, "resource")}
            </Typography>
          )}
        </TextEllipsis>
      </Box>
    </TableSimpleCell>
  );
};

export default ScansTableUnmanagedResourcesCell;
